import { updatePlan } from '@wix/ambassador-pricing-plans-v2-plan/http';
import { isNotOptional } from '@wix/seo-common-core';
import { chunk as getChunks } from 'lodash';
import { fetchPricingPlans } from '../new-infra-fetchers/fetch-pricing-plans';
import { buildPricingPlansBulkUpdatePayload } from './build-payloads/bulk-update-pricing-plans-alt-update-payload-builder';
const BULK_LIMIT = 100;
export const updatePricingPlansAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.id).filter(isNotOptional);
  try {
    const plans = await fetchPricingPlans(httpClient, errorHandler, entityIdsList);
    const plansMap = new Map(plans.map(plan => [plan.id, plan]));
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const results = [];
    for (const chunk of chunks) {
      const payload = buildPricingPlansBulkUpdatePayload(chunk, plansMap);
      if (payload.length === 0) {
        results.push({
          success: false
        });
        allFailedElements.push(...chunk);
        continue;
      }
      const chunkPromises = payload.map(async plan => {
        const {
          data: {
            plan: updatedPlan
          }
        } = await withErrorHandler(async () => httpClient.request(updatePlan(plan)), {
          errorCodesMap: {
            applicationError: {
              PRICING_PLANS_NOT_INSTALLED: false,
              plan_not_found: false
            }
          }
        });
        return {
          success: !!updatedPlan
        };
      });
      const chunkResults = await Promise.all(chunkPromises);
      const success = chunkResults.every(result => result.success);
      if (!success) {
        const failedIndexes = (chunkResults ?? []).map((_item, index) => index).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      results.push({
        success
      });
    }
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-pricing-plans-alt-text.js.map